import moment from "moment"


export const timeBetweenDatesInMs = (startDate: Date | string, endDate: Date | string | null) => {
    const startMoment = moment(startDate);
    const endMoment = endDate ? moment(endDate) : moment();
    if (!startMoment.isValid() || !endMoment.isValid()) {
        return null;
    }
    return endMoment.diff(startMoment);
}

export const formattedTimeBetweenDates = (startDate: Date | string, endDate: Date | string | null) => {
    const diff = timeBetweenDatesInMs(startDate, endDate);
    if (diff === null) {
        return null;
    }
    const duration = moment.duration(diff);
    const days = Math.floor(duration.asDays());
    const hours = duration.hours(); 
    const minutes = duration.minutes(); 
    return { days, hours, minutes };

}
